import { API } from './resources'

export default {
  get: (subject, message) => {
    return API.get('/version')
  }
}
